import React from 'react';

import { Button, Text, Title } from '@soluto-design/react';
import cls from '@soluto-design/styles/cls';

import { useIntersectionObserver } from '../../../hooks/useIntersectionObserver';
import CardBase from '../CardBase';

interface Platform {
    name: string;
    url: string;
    icon?: string;
}

export interface CardPodcastProps {
    title?: string;
    text?: string;
    episodeId: string;
    platforms?: Platform[];
}

export default function CardPodcast({
    title,
    text,
    platforms,
    episodeId,
}: CardPodcastProps) {
    const { isIntersecting, ref } = useIntersectionObserver({
        threshold: 0.25,
        freezeOnceVisible: true,
    });
    return (
        <>
            <CardBase
                ref={ref}
                className={cls(
                    'flex flex-col min-h-[492px] xl:min-h-[540px] p-lg overflow-hidden rounded-large bg-background-secondary justify-between',
                )}>
                <div className="min-h-80">
                    {isIntersecting && (
                        <iframe
                            title={title}
                            src={`https://widget.spreaker.com/player?episode_id=${episodeId}&theme=light&playlist=false&playlist-continuous=false&autoplay=false&live-autoplay=false&chapters-image=true&episode_image_position=right&hide-logo=false&hide-likes=false&hide-comments=false&hide-sharing=false&hide-download=true&data-color=FF0000`}
                            width="100%"
                            height="80px"
                            frameBorder="0"
                        />
                    )}
                </div>
                <div className="flex-1">
                    <Title
                        component="h6"
                        className="text-h400 text-text-primary mt-40">
                        {title}
                    </Title>
                    {text && (
                        <Text
                            component="div"
                            isHtml
                            className="text-text-secondary text-b400 mt-xs [&>p]:mt-xs [&>p]:mb-xs [&>p:last-child]:mb-0 [&>div]:mt-xs [&>div]:mb-xs [&>div:last-child]:mb-0">
                            {text}
                        </Text>
                    )}
                </div>

                {platforms && platforms?.length > 0 && (
                    <div className="flex flex-wrap gap-8 pt-40 flex-initial md:items-center">
                        {platforms?.map((platform) => {
                            return (
                                <Button
                                    key={platform.name}
                                    href={platform.url}
                                    className="basis-full md:basis-auto"
                                    variant="tertiary"
                                    size="large"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    leftIcon={platform.icon}>
                                    {platform.name}
                                </Button>
                            );
                        })}
                    </div>
                )}
            </CardBase>
        </>
    );
}
